import { render, staticRenderFns } from "./ErpQuotationsList.vue?vue&type=template&id=096daf9a&scoped=true&"
import script from "./ErpQuotationsList.vue?vue&type=script&lang=js&"
export * from "./ErpQuotationsList.vue?vue&type=script&lang=js&"
import style0 from "./ErpQuotationsList.vue?vue&type=style&index=0&id=096daf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096daf9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
